<template>
  <v-slide-y-transition>
    <v-sheet
      v-if="show"
      class="bottom-bar"
      elevation="4"
    >
      <v-container class="py-2">
        <v-row align="center" no-gutters>
          <v-col>
            <div class="text-subtitle-1">
              Επιλεγμένα: <strong>{{ totalSelectedItems }}</strong>
            </div>
          </v-col>
          <v-col cols="auto">
            <v-btn
              v-if="step === 1"
              color="primary"
              rounded
              class="px-6"
              @click="$emit('next-step')"
            >
              Επόμενο
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              v-else-if="step === 2"
              color="success"
              rounded
              class="px-6"
              @click="$emit('save-selected')"
            >
              Έκδοση 
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-slide-y-transition>
</template>

<script>
export default {
  name: 'SDABottomBar',
  props: {
    step: {
      type: Number,
      required: true
    },
    totalSelectedItems: {
      type: Number,
      default: 0
    },
    hasSelectedItems: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show() {
      return (this.hasSelectedItems && this.step === 1) || 
             (this.step === 2 && this.totalSelectedItems > 0)
    }
  }
}
</script>

<style scoped>
.bottom-bar {
  background-color: #11111199;
  backdrop-filter: blur(10px);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
}
</style> 